var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEducationFacilityUniversity = function SvgEducationFacilityUniversity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m13.3 10.1 6.3 2.4c.6.2.9.8 1 1.4v6.4c0 1-.8 1.7-1.7 1.7H5.7c-1 0-1.7-.7-1.7-1.7v-6.4c0-.6.4-1.2.9-1.4l6.4-2.4V3c0-.6.4-1 1-1 .1 0 .2 0 .4.1l5.7 2.5c.4.1.6.5.6.9s-.2.7-.5.9l-5.2 2.2V10zm0-5.6v1.9l2.2-.9zM6 14.2V20h12.4v-5.8l-6.2-2.3zm7.491 4.918c-.335.161-.731.242-1.19.242-.45 0-.845-.08-1.182-.242a1.865 1.865 0 0 1-.781-.677 1.865 1.865 0 0 1-.279-1.023V14h1.327v3.291c0 .302.08.54.24.713.158.17.385.256.68.256.298 0 .526-.085.683-.256.156-.174.235-.411.235-.713V14h1.327v3.418c0 .388-.093.728-.278 1.02a1.83 1.83 0 0 1-.782.68",
    clipRule: "evenodd"
  })));
};
export default SvgEducationFacilityUniversity;